<template>
	<div class="w-100">
		<div 
			v-if="wrapper_size == 'full'"
			class="popup-wrapper z-index-1045 position-fixed" 
			:class="classPopup"
			:style="stylePopup" 
			:ref="`${id_ref}_up`">
			<div v-if="title != ''" class="row no-gutters py-3">
				<div class="col-9 align-self-center">
    			<p class="mb-0 pl-4 sub-heading-1-1">{{title}}</p>
				</div>
				<div class="col-3 align-self-center text-right">
					<div class="border-semi-grey rounded-circle mr-4 cursor-pointer" style="display:inline-flex;padding:10px;" @click="closePopup(false)">
						<img src="../../assets/img/icon/close.png" width="14" />
					</div>
				</div>
			</div>
			<div class="w-100" :style="{
				maxHeight: title == '' ? '90vh' : '80vh',
				overflowY: 'auto'
			}">
				<slot name="body"></slot>
			</div>
		</div>
		<transition name="fade">
			<div v-if="wrapper_size == 'full' && show" class="w-100 z-index-1042" @click="closePopup()" style="height: 100vh;background-color: #00000099;position: fixed;top:0;left:0px;right:0px;"></div>
		</transition>
		<div v-if="wrapper_size == 'mobile'" class="position-fixed w-100 z-index-1045" style="bottom:0px;left:0px;right:0px;">
			<b-row class="justify-content-center" no-gutters>
				<b-col v-if="widthScreen > 575" @click="closePopup()" :class="{
					'fit-to-screen': wrapper_size == 'mobile' && show
				}"></b-col>
	  		<b-col cols="12" sm="8" md="6" lg="4" xl="4" :class="{
	  			'fit-to-screen': wrapper_size == 'mobile' && show
	  		}">
	  			<div class="w-100" :style="{
	  				'height': `${mobile_height_top_free}px`
	  			}" @click="closePopup()">
	  			</div>
	  			<div 
						class="popup-wrapper position-absolute" 
						:class="classPopup"
						:style="stylePopup" 
						:ref="`${id_ref}_bottom`">
						<div v-if="title != ''" class="row no-gutters py-3">
							<div class="col-9 align-self-center">
			    			<p class="mb-0 pl-4 sub-heading-1-1">{{title}}</p>
							</div>
							<div class="col-3 align-self-center text-right">
								<div class="border-semi-grey rounded-circle mr-4" style="display:inline-flex;padding:10px;" @click="closePopup(false)">
									<img src="../../assets/img/icon/close.png" width="14" />
								</div>
							</div>
						</div>
						<div class="w-100" :style="bodyMaxHeight">
							<slot name="body"></slot>
						</div>
						<div class="w-100" v-if="use_footer" style="height:13vh;">
							<slot name="footer"></slot>
						</div>
					</div>
	  		</b-col>
	  		<b-col v-if="widthScreen > 575" @click="closePopup()" :class="{
	  			'fit-to-screen': wrapper_size == 'mobile' && show
	  		}"></b-col>
	  	</b-row>
	  </div>
		<div v-if="wrapper_size == 'mobile' && show" class="w-100 z-index-1042" @click="closePopup()" style="height: 100vh;background-color: #00000099;position: fixed;top:0;left:0px;right:0px;">
		</div>
	</div>
</template>
<script>
	export default{
		props:{
			direction:{
				type: String,
				default: 'bottom'
			},
			size:{
				type: Number,
				default: 90
			},
			use_max_size:{ //only for y direction
				type:Boolean,
				default: false	
			},
			show:{
				type: Boolean,
				default: false
			},
			title:{
				type: String,
				default: ''
			},
			wrapper_size:{
				type: String,
				default: 'full'
			},
			id_ref:{
				type: String,
				default: 'popup'
			},
			use_footer:{
				type: Boolean,
				default: false
			},
			no_close_backdrop:{
				type: Boolean,
				default: false
			}
		},
		data(){
			return{
				mobile_height_top_free: 0
			}
		},
		destroyed(){
			document.body.style.overflow = "auto";
		},
		computed:{
			direction_appear(){
				return this.direction == 'top' || this.direction == 'bottom' ? 'y' : 'x'
			},
			stylePopup(){
				let data_return = {}

				if(this.use_max_size){
					data_return.width = this.wrapper_size == 'full' ? '100vw' : '100%'
					data_return.maxHeight = '90vh'
				}else{
					data_return.width = this.direction_appear == 'x' ? `${this.size}vw` : '100%'
					data_return.height = this.direction_appear == 'y' ? `${this.size}vh` : '100vh'
				}

				if(this.direction_appear == 'x'){
					data_return.top = 0
					data_return.transform = this.direction == 'left' ? `translate3d(-100vw, 0, 0)` : `translate3d(100vw, 0, 0)`
				}else{
					data_return.left = 0
					data_return.transform = this.direction == 'top' ? `translate3d(0, -100vh, 0)` : `translate3d(0, 100vh, 0)`
				}
				data_return[this.direction] = 0

				return data_return
			},
			classPopup(){
				if(this.show){
					let data_return = this.direction_appear == 'x'?'show-x' : 'show-y'
					if(this.direction == 'top'){
						data_return += ' radius-12-b'
					}else if(this.direction == 'bottom'){
						data_return += ' radius-12-t'
					}
					return data_return
				}else{
					return ''
				}
			},
			bodyMaxHeight(){
				let height = 90
				if(this.title != ''){
					height -= 10
				}
				if(this.use_footer){
					height -= 13
				}
				return {
					maxHeight: `${height}vh`,
					overflowY: 'auto'
				}
			},
			widthScreen(){
				return window.innerWidth
			}
		},
		watch:{
			show(){
				if(this.show){
					document.body.style.overflow = "hidden";
				}else{
					document.body.style.overflow = "auto";
				}
			},
			classPopup(){
				if(this.show){
					this.$nextTick(()=>{
						let height = this.$refs[`${this.id_ref}_bottom`];
						if(height == undefined){
							this.mobile_height_top_free = 0
						}else{
							this.mobile_height_top_free = height.offsetTop
						}
					})
				}else{
					this.mobile_height_top_free = 0
				}
			}
		},
		methods:{
			toggleAppear(){
				let wrapper = document.querySelector('#popupWrapper');
				let data_show = this.direction_appear == 'x' ? 'show-x' : 'show-y'
				if(this.show){
					wrapper.classList.add(data_show);
  				// document.body.style.overflow = "hidden";
				}else{
					wrapper.classList.remove(data_show);
  				// document.body.style.overflow = "auto";
				}
			},
			closePopup(is_backdrop=true){
				if(!(this.no_close_backdrop && is_backdrop)){
					this.$emit("close")
				}
			}
		}
	}
</script>
<style scoped>
	.popup-wrapper{
    background-color: #FFF;
    transition: transform .3s;
    transition-delay: 0.1s
	}
	.popup-wrapper.show-x {
    transform: translate3d(0vw, 0, 0) !important;
	}
	.popup-wrapper.show-y {
    transform: translate3d(0, 0vh, 0) !important;
	}	
</style>


// WEBPACK FOOTER //
// src/components/general/PopupDetail.vue